import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

export const CIRCLE_WIDTH = 40;

export const getStrokeWidth = (size) => {
  let width;
  if (size <= 24) {
    width = 3;
  } else if (size > 24 && size <= 32) {
    width = 4;
  } else if (size > 32 && size <= 48) {
    width = 5;
  } else if (size > 48 && size <= 96) {
    width = 6;
  } else {
    width = 6;
  }
  return width;
};

export default {
  Svg: styled.svg`
    display: block;
    max-width: 100%;
    width: ${props => `${props.size}px`};
    height: ${props => `${props.size}px`};
    ${({ rtl }) =>
    rtl &&
      css`
        transform: scale(-1, 1);
      `}
  `,
  Circle1: styled.circle`
    ${({ $theme }) => css`stroke: ${$theme.track};`}
    fill: none;
  `,
  Circle2: styled.circle`
    ${({ $disableAnimation }) => !$disableAnimation && css`
      transition: stroke-dashoffset 100ms cubic-bezier(0.4,0,1,1);
    `}
    fill: none;
    stroke-linecap: round;
    transform: rotate(-90deg);
    transform-origin: center;
  `,
  InnerLabelText: styled.text`
    ${Tokens.TYPOGRAPHY.CAPTION}
    ${({ $theme }) => css`fill: ${$theme.text};`}
    text-anchor: middle;
    ${({ rtl }) =>
    rtl &&
      css`
        transform: scale(-1, 1);
        transform-origin: center;
      `}
  `,
  OuterLabelText: styled.span`
    margin-left: ${props => `calc(${props.center}px - 10px)`};
    ${Tokens.TYPOGRAPHY.CAPTION}
    ${({ $theme }) => css`color: ${$theme.text};`}
    text-align: center;
  `,
};